(function () {
  function initReveals(root) {
    const nodes = root.querySelectorAll ? root.querySelectorAll('.pmf-gala-reveal:not([data-pmf-reveal-init])') : [];
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window)) {
      nodes.forEach((el) => {
        el.dataset.pmfRevealInit = '1';
        el.classList.add('is-in');
      });
      return;
    }

    const observer = new IntersectionObserver((entries, io) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    nodes.forEach((el) => {
      el.dataset.pmfRevealInit = '1';
      observer.observe(el);
    });
  }

  function initFaq(root) {
    const faqs = root.querySelectorAll ? root.querySelectorAll('.pmf-gala-faq[data-one-open="true"]:not([data-pmf-faq-init])') : [];
    faqs.forEach((faq) => {
      faq.dataset.pmfFaqInit = '1';
      faq.querySelectorAll('.pmf-gala-faq-item').forEach((item) => {
        item.addEventListener('toggle', () => {
          if (!item.open) return;
          faq.querySelectorAll('.pmf-gala-faq-item').forEach((other) => {
            if (other !== item) other.open = false;
          });
        });
      });
    });
  }

  function initSticky(root) {
    const stickies = root.querySelectorAll ? root.querySelectorAll('.pmf-gala-sticky-buy:not([data-pmf-sticky-init])') : [];
    stickies.forEach((sticky) => {
      sticky.dataset.pmfStickyInit = '1';
      const hero = sticky.closest('.pmf-gala-hero');
      const targetId = sticky.dataset.ticketsTarget || 'pmf-gala-tickets';
      const tickets = document.getElementById(targetId);
      if (!hero || !tickets) {
        sticky.classList.add('is-showing');
        return;
      }

      const update = () => {
        const heroBottom = hero.getBoundingClientRect().bottom;
        const ticketsRect = tickets.getBoundingClientRect();
        const ticketsInView = ticketsRect.top < window.innerHeight * 0.3 && ticketsRect.bottom > 0;
        const pastHero = heroBottom < window.innerHeight * 0.7;
        sticky.classList.toggle('is-showing', pastHero && !ticketsInView);
      };

      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  function init(root) {
    initReveals(root || document);
    initFaq(root || document);
    initSticky(root || document);
  }

  window.PMFGala2026Init = init;

  if (!window.PMFGala2026Booted) {
    window.PMFGala2026Booted = true;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(document));
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:block:select', (event) => {
      const el = event.target.closest ? event.target.closest('.pmf-gala-reveal') : null;
      if (el) el.classList.add('is-in');
    });
  } else {
    init(document);
  }
})();